import { Http } from "@repo/http"

import { PLATFORM_BASE_URL } from "../const"
import type { SmmAuthConfig } from "../types"
import { resolveBaseUrl } from "../utils"

const http = new Http()
http.setDefaultConfig({
  baseURL: resolveBaseUrl(PLATFORM_BASE_URL),
  timeout: 10000,
  getToken: async () => {
    if (typeof window === "undefined") {
      const { cookies } = await import("next/headers")
      const cookieStore = await cookies()
      if (!process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY) {
        return ""
      }
      const token = cookieStore.get(process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY)?.value || ""
      return token
    }
  },
  getLang: async () => {
    if (typeof window === "undefined") {
      const { cookies } = await import("next/headers")
      const cookieStore = await cookies()
      const lang = cookieStore.get("locale")?.value || "en"
      return lang
    }
  },
  log: {
    enable: false,
  },
})

http.addErrorInterceptor(async (error) => {
  return true
})

export const configureHttp = (config: Pick<SmmAuthConfig, "apiBaseUrl" | "cookieName">): void => {
  http.setDefaultConfig({
    baseURL: config.apiBaseUrl,
    cookieName: config.cookieName,
  })
}

export default http
